import type { CloudAgentRunAuditRunView } from "@/view-models/cloud-agent-run-audit";
import {
  getIntegrationCatalogDisplayName,
  getIntegrationCatalogTools,
} from "../Settings/components/integrations/integrationCatalog";

const uniqueValues = (values: Array<string | null | undefined>): string[] =>
  Array.from(
    new Set(values.map((value) => String(value || "").trim()).filter(Boolean)),
  );

export const getAuditApplicationDisplayName = (
  value?: string | null,
): string => getIntegrationCatalogDisplayName(value);

export const getRunAuditApplications = (
  run: CloudAgentRunAuditRunView,
): string[] =>
  uniqueValues([
    ...run.applications.map((application) => application.platformLabel),
    ...run.timeline.map((event) => event.platformLabel),
  ].map(getAuditApplicationDisplayName));

export const getAuditApplicationFilterValues = (
  runs: CloudAgentRunAuditRunView[],
): string[] => {
  const applications = uniqueValues(runs.flatMap(getRunAuditApplications));
  const catalogOrder = new Map(
    getIntegrationCatalogTools().map((application, index) => [
      application.toLocaleLowerCase(),
      index,
    ]),
  );

  return applications.sort((first, second) => {
    const firstIndex = catalogOrder.get(first.toLocaleLowerCase());
    const secondIndex = catalogOrder.get(second.toLocaleLowerCase());
    if (firstIndex !== undefined || secondIndex !== undefined) {
      return (
        (firstIndex ?? Number.MAX_SAFE_INTEGER) -
        (secondIndex ?? Number.MAX_SAFE_INTEGER)
      );
    }
    return first.localeCompare(second);
  });
};
